
import { useQuizStore } from '@/store/quiz'
import { computed, defineComponent, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import dayjs from 'dayjs'
import BaseInput from '@/components/BaseInput.vue'
import BaseButton from '@/components/BaseButton.vue'

export default defineComponent({
  name: 'quiz-view',
  components: { BaseInput, BaseButton },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const store = useQuizStore()
    const name = ref('')

    store.fetchQuiz(route.params.id as string)

    function formatDate(timestamp: number) {
      return dayjs(timestamp).fromNow()
    }

    function startTest() {
      store.startQuiz(route.params.id as string, name.value)
      router.push('/begin-quiz/' + route.params.id)
    }

    return {
      store,
      formatDate,
      startTest,
      name,
      isJoinable: computed(
        () =>
          dayjs(store.currentQuiz!.startedAt).isBefore(dayjs()) &&
          (!store.currentQuiz!.closesAt ||
            dayjs(store.currentQuiz!.closesAt).isAfter(dayjs()))
      ),
    }
  },
})
